import { composeValidators } from '@reliance/forms-js/lib/validation';
import React, { ChangeEventHandler } from 'react';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import { Field } from 'react-final-form';

type CheckboxProps = {
  name: string;
  id?: string;
  label: string|JSX.Element;
  validationRules?: any[];
  helperText?: string;
  value?: any;
  disabled?: boolean;
  type?: 'checkbox'|'switch'|'radio';
  onChange?: ChangeEventHandler | undefined;
}

const Checkbox: React.FC<CheckboxProps> = (props) =>
  <Field
    name={props.name}
    value={props.value}
    type="checkbox"
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) =>
      <FormGroup>
        <Form.Check
          {...input}
          id={props.id || `checkbox-${props.name}`}
          disabled={props.disabled == true}
          label={props.label}
          onChange={(e) => {
            input.onChange(e);
            props.onChange?.(e);
          }}
          type={props.type == 'switch' ? 'switch' : 'checkbox'} />
        {((meta.error && meta.touched) || props.helperText) &&
          <span className="help-block has-error">{meta.error && meta.touched ? meta.error : props.helperText}</span>
        }
      </FormGroup>
    }
  </Field>

export const StandaloneCheckbox: React.FC<CheckboxProps> = (props) =>
  <Field
    name={props.name}
    type="checkbox"
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) =>
      <Form.Check
        {...input}
        id={props.id || `checkbox-${props.name}`}
        disabled={props.disabled == true}
        label={props.label}
        type={props.type == 'switch' ? 'switch' : 'checkbox'} />
    }
  </Field>

export default Checkbox;